import { Button } from "@shared/ui";
import { DisabledPopover } from "@shared/ui/DisabledPopover";
import { Copy, FileText, Plus } from "lucide-react";
import styles from "../empty.module.scss";

interface EmptyBriefStateProps {
  isDisabled: boolean;
  onCopy: () => void;
  onAdd: () => void;
}

export function EmptyBriefState({
  isDisabled,
  onCopy,
  onAdd,
}: EmptyBriefStateProps) {
  return (
    <div className={styles.emptyBriefState}>
      <div className={styles.emptyBriefIcon}>
        <FileText size={18} />
      </div>
      <p className={styles.emptyBriefText}>No brief added yet.</p>
      <div className={styles.emptyBriefActions}>
        <DisabledPopover isDisabled={isDisabled}>
          <Button
            disabled={isDisabled}
            onClick={onCopy}
            className={styles.copyButton}
          >
            <Copy size={14} /> Copy from other creator
          </Button>
        </DisabledPopover>
        <DisabledPopover isDisabled={isDisabled}>
          <Button onClick={onAdd} type="primary" className={styles.addButton}>
            <Plus size={14} /> Add a brief
          </Button>
        </DisabledPopover>
      </div>
    </div>
  );
}
